export enum Action {
  CHANGE_PERFORMER = 'change-performer',
  SHOW_CARGO_LOCATION = 'show-cargo-location',
  SHOW_ADDITIONAL_PAYMENTS = 'show-additional-payments',
  RESEND_CARGO_T0_1C = 'resend-cargo-to-1c',
  SHOW_CARGO_TRANSPORT = 'show-cargo-transport',
  SET_TRASH = 'set-trash',
  MOVE_TO_SVH = 'move-to-svh',
  CALCULATE_RATE = 'calculate-rate',
  MOVE_TO_DELIVERY = 'move-to-delivery',
  SET_ARCHIVE = 'set-archive',
  VIEW_LOADING_DETAILS = 'view-loading-details',
  CREATE_SPECIFICATION = 'create-specification',
  OPEN_SPECIFICATION = 'open-specification',
}
